import { round } from 'helpers/formulas';
import { roundByTickSize } from 'helpers/utils';

import { useSelectedProductStoreBase } from './selectedProduct.store';
import { SelectedProductStore } from './selectedProduct.types';

// ======= Store Selectors - To be used with functions outside react (NON-REACTIVE) =======

// #region Store Selectors
const selectedProductStateSelector = () => {
  return useSelectedProductStoreBase.getState().state;
};

const selectedProductSpotPriceSelector = (tickSize: number) => {
  const selectedProductState = selectedProductStateSelector();
  const { spotPrice } = selectedProductState;
  return spotPrice !== undefined ? roundByTickSize(tickSize)(spotPrice) : undefined;
};

const selectedProductMarkPriceSelector = (precision: number) => {
  const selectedProductState = selectedProductStateSelector().markPrice;
  const { price } = selectedProductState;
  return round(Number(price), precision);
};

const selectedProductMarkDataSelector = () => {
  return selectedProductStateSelector().markPrice;
};

const selectedProductPriceAlertCoinSpotIndexSymbolSelector = () => {
  const selectedProductState = selectedProductStateSelector().selectedPriceAlertCoin;
  const { indexSymbol } = selectedProductState;
  return indexSymbol;
};

const selectedProductFundingDataSelector = () => {
  return selectedProductStateSelector().fundingData;
};

const selectedProductPriceBandSelector = () => {
  return selectedProductStateSelector().markPrice.price_band;
};

// #endregion Store Selectors

// ====== React Based Selectors ======
// Ex: const spotPriceValue = useSelectedProductStoreBase(selectProductSpotPrice);
// #region Reactive Data Selectors
const selectProductSpotPrice = (store: SelectedProductStore) => store.state.spotPrice;

const selectProductMarkPriceObject = (store: SelectedProductStore) =>
  store.state.markPrice;

const selectProductMarkPrice = (store: SelectedProductStore) =>
  store.state.markPrice.price;

const selectProductSelectedPriceAlertCoinSpotPrice = (store: SelectedProductStore) =>
  store.state.selectedPriceAlertCoin.spotPrice;

const selectProductSelectedPriceAlertCoinIndexSymbol = (store: SelectedProductStore) =>
  store.state.selectedPriceAlertCoin.indexSymbol;

const selectEstimatedFundingRate = (store: SelectedProductStore) =>
  store.state.fundingData.estimatedFundingRate ?? 0;

const selectNextFundingRealization = (store: SelectedProductStore) =>
  store.state.fundingData.nextFundingRealization ?? 0;

const selectFundingRate = (store: SelectedProductStore) =>
  store.state.fundingData.fundingRate ?? 0;

const selectFundingInterval = (store: SelectedProductStore) =>
  store.state.fundingData.fundingInterval ?? 0;

const selectPriceBand = (store: SelectedProductStore) => store.state.markPrice.price_band;

// #endregion Reactive Data Selectors

export {
  // #region Store Selectors (NON-REACTIVE)
  selectedProductStateSelector,
  selectedProductSpotPriceSelector,
  selectedProductMarkPriceSelector,
  selectedProductPriceAlertCoinSpotIndexSymbolSelector,
  selectedProductMarkDataSelector,
  selectedProductFundingDataSelector,
  selectedProductPriceBandSelector,
  // #endregion

  // #region Reactive Selectors (use with useSelectedProductStoreBase)
  selectProductSpotPrice,
  selectProductMarkPriceObject,
  selectProductMarkPrice,
  selectProductSelectedPriceAlertCoinSpotPrice,
  selectProductSelectedPriceAlertCoinIndexSymbol,
  selectEstimatedFundingRate,
  selectNextFundingRealization,
  selectFundingRate,
  selectFundingInterval,
  selectPriceBand,
  // #endregion
};
